<template>
  <div>
    <b-container fluid class="gen-header">
      <b-row>
        <b-col sm="12">
          <div class="childs">
            <div class="page-title">Products & Services</div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <service-data></service-data>
    <call-us></call-us>
  </div>
</template>

<script>
// @ is an alias to /src
import ServiceData from "@/components/ServiceData.vue";
import CallUs from "@/components/CallUs.vue";

export default {
  created() {
    document.title = "Products & Services";
  },
  name: "Services",
  data() {
    return {
      drawer: true,
      images: {
        headImage: require("@/assets/bgparallax-01.jpg")
      },
      data: [],
      items: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "Product & Services",
          href: "/products-services",
          active: true
        }
      ]
    };
  },
  components: {
    "service-data": ServiceData,
    "call-us": CallUs
  }
};
</script>
<style scoped></style>
